<template>
</template>

<script>

	const host = 'https://'+ document.domain;
	const hostAuto = window.location.protocol+'//'+ document.domain;

	// var host = 'https://'+ 'test.ttq.so';
	// var hostAuto = "http" +'//'+ 'www.ttq.so';
  export default
	{
	  host,
    hostAuto
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Global.vue?14e78f73